import type { IOrgRepository } from '../repositories/IOrgRepository.js';

export interface DeleteOrgInput {
  id: string;
}

interface Dependencies {
  orgRepository: IOrgRepository;
}

export function createDeleteOrgUseCase({ orgRepository }: Dependencies) {
  return async function deleteOrg(input: DeleteOrgInput): Promise<void> {
    return orgRepository.delete(input.id);
  };
}
